<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row class="m-0 mb-1 elevation-1" style="max-height: 2.55rem">
        <v-col class="p-0">
          <v-row class="m-0" style="height: 2.55rem">
            <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">Arbeitszeitraster (Referenz)</span>
          </v-row>
        </v-col>
      </v-row>

      <v-alert
          type="info"
          dense
          outlined
          class="mx-3 mt-2 mb-2"
      >
        <div class="d-flex align-center">
          <span>
            Referenzansicht: Die Arbeitszeitraster werden in Personalwesen › Stammdaten › Arbeitszeitraster
            gepflegt (Tabelle bd_azra). Die Dienstplanung verwendet sie nur zur Auswahl und Zuweisung.
          </span>
          <v-spacer></v-spacer>
          <v-btn
              v-if="canAdmin"
              text
              small
              color="primary"
              class="ml-2"
              @click="$router.push('/basis/azra')"
          >
            <v-icon left small>mdi-open-in-app</v-icon>
            Zur Rasterpflege
          </v-btn>
        </div>
      </v-alert>

      <v-alert
          v-if="schemaMissing"
          type="info"
          outlined
          class="mx-3"
      >
        Die Dienstplanung ist für diesen Mandanten noch nicht eingerichtet.
      </v-alert>

      <v-row v-else class="m-0" style="flex: 1 1 auto;">
        <!-- pattern list -->
        <v-col cols="12" md="3" class="p-0 list-col">
          <div class="pa-2">
            <v-text-field
                v-model="search"
                label="Suchen (Name, Nummer)"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                hide-details
                clearable
            ></v-text-field>
          </div>
          <v-divider></v-divider>
          <div class="list-scroll">
            <v-list dense>
              <v-list-item-group v-model="selectedBisId" color="primary">
                <v-list-item
                    v-for="r in filteredRaster"
                    :key="r.bis_id"
                    :value="r.bis_id"
                >
                  <v-list-item-content>
                    <v-list-item-title><b>{{ r.name }}</b></v-list-item-title>
                    <v-list-item-subtitle>
                      Nr. {{ r.bis_id }} · {{ r.count_phases }} {{ r.count_phases === 1 ? 'Phase' : 'Phasen' }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action v-if="!r.count_phases" class="my-0">
                    <v-icon small color="red" title="Für dieses Raster sind keine Phasen hinterlegt.">
                      mdi-alert-circle
                    </v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
              <v-list-item v-if="!filteredRaster.length">
                <v-list-item-content>
                  <v-list-item-subtitle>Keine Arbeitszeitraster gefunden.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-col>

        <!-- read-only detail -->
        <v-col cols="12" md="9" class="p-0 detail-col">
          <div v-if="!detail" class="pa-6 grey--text">
            Bitte links ein Arbeitszeitraster auswählen.
          </div>
          <template v-else>
            <v-row class="m-0 elevation-1" style="height: 2.55rem">
              <span style="margin-top: auto; margin-bottom: auto; margin-left: 12px;" class="text-h6">
                {{ detail.main_azra.bis_id }} {{ detail.main_azra.name }}
              </span>
              <v-spacer></v-spacer>
              <v-btn v-if="currentPhase" small text color="primary" style="margin: auto 8px auto 0"
                     title="Diese Woche in der Musterzuordnung vorauswählen" @click="imPlanerVerwenden">
                <v-icon small left>mdi-arrow-right-bold-box-outline</v-icon>Im Planer verwenden
              </v-btn>
            </v-row>
            <div v-if="!phases.length" class="pa-6 grey--text">
              Für dieses Arbeitszeitraster sind keine Phasen hinterlegt.
            </div>
            <template v-else>
              <v-row class="m-0" style="flex: 0 0 auto;">
                <v-col class="p-0 tabs-col">
                  <v-tabs v-model="phaseTab" show-arrows>
                    <v-tab v-for="phase in phases" :key="phase.key">
                      {{ phase.name }}
                    </v-tab>
                  </v-tabs>
                  <v-tabs v-if="currentPhase && currentPhase.weeks.length > 1" v-model="weekTab" show-arrows>
                    <v-tab v-for="(week, i) in currentPhase.weeks" :key="weekKey(week, i)">
                      Woche {{ i + 1 }}
                    </v-tab>
                  </v-tabs>
                </v-col>
                <v-col class="custom-col-1" style="padding: 4px">
                  <v-text-field
                      label="Wochenstunden"
                      dense
                      outlined
                      readonly
                      hide-details
                      :value="sumValenceWeekHours"
                  ></v-text-field>
                </v-col>
                <v-col class="custom-col-1" style="padding: 4px">
                  <v-text-field
                      label="Soll-Wochenstunden"
                      dense
                      outlined
                      readonly
                      hide-details
                      :value="sumWeekHours"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="m-0" v-if="currentAzra">
                <v-col
                    class="p-0 p-3 day-col"
                    v-for="day in days"
                    :key="day.day"
                >
                  <h6 style="text-align: center">{{ day.day_name }}</h6>
                  <v-text-field
                      class="mt-5"
                      label="Sollstunden"
                      filled
                      readonly
                      hide-details
                      :value="displayHours(currentAzra['hours_' + day.day])"
                  ></v-text-field>
                  <v-text-field
                      class="mt-5"
                      label="Wertigkeit"
                      outlined
                      readonly
                      hide-details
                      :value="displayValence(currentAzra['valence_hours_' + day.day])"
                  ></v-text-field>
                  <v-text-field
                      class="mt-5"
                      label="Arbeitszeit"
                      outlined
                      readonly
                      hide-details
                      :value="displayRange(currentAzra['time_' + day.day])"
                  ></v-text-field>
                  <v-text-field
                      class="mt-5"
                      label="Pause 1"
                      outlined
                      readonly
                      hide-details
                      :value="displayRange(currentAzra['break_1_' + day.day])"
                  ></v-text-field>
                  <v-text-field
                      class="mt-5"
                      label="Pause 2"
                      outlined
                      readonly
                      hide-details
                      :value="displayRange(currentAzra['break_2_' + day.day])"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
          </template>
        </v-col>
      </v-row>
    </div>

    <v-snackbar
        v-model="showErrorMessage"
        :timeout="6000"
        right
        color="red accent-2"
    >
      <b>{{ errorMessage }}</b>

      <template v-slot:action="{ attrs }">
        <v-btn
            icon
            color="white"
            v-bind="attrs"
            @click="showErrorMessage = false"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>

<script>
import {Redirect_Login} from "@/shared/utils";
import {dpApi, errorText, isAuthError, WOCHENTAGE} from "@/shared/dienstplan_api";

const DAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
const HOURS_PATTERN = /^(\d{1,2}):([0-5]\d)$/;

export default {
  name: "Arbeitszeitraster",
  data() {
    return {
      days: DAY_KEYS.map((day, i) => ({day: day, day_name: WOCHENTAGE[i]})),
      settings: null,
      raster: [],
      search: '',
      selectedBisId: undefined,
      detail: null,
      requestedBisId: null,
      phaseTab: 0,
      weekTab: 0,
      loader: undefined,
      pending: 0,
      schemaMissing: false,
      showErrorMessage: false,
      errorMessage: '',
    };
  },
  computed: {
    canAdmin() {
      return !!(this.settings && this.settings.can_admin);
    },
    filteredRaster() {
      const search = (this.search || '').trim().toLowerCase();
      return this.raster
          .filter(r => !search
              || String(r.name || '').toLowerCase().includes(search)
              || String(r.bis_id).toLowerCase().includes(search))
          .slice()
          .sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')));
    },
    // sub_azras grouped by (active_from, active_to), ordered by active_from;
    // weeks of a phase ordered by week_order
    phases() {
      if (!this.detail) {
        return [];
      }
      const map = new Map();
      (this.detail.sub_azras || []).forEach(a => {
        const key = a.active_from + '|' + a.active_to;
        if (!map.has(key)) {
          map.set(key, {key: key, name: this.formatName(a), active_from: a.active_from, weeks: []});
        }
        map.get(key).weeks.push(a);
      });
      const res = Array.from(map.values());
      res.forEach(p => p.weeks.sort((a, b) => (parseInt(a.week_order) || 0) - (parseInt(b.week_order) || 0)));
      res.sort((a, b) => String(a.active_from).localeCompare(String(b.active_from)));
      return res;
    },
    currentPhase() {
      return this.phases[this.phaseTab] || this.phases[0] || null;
    },
    currentAzra() {
      if (!this.currentPhase) {
        return null;
      }
      return this.currentPhase.weeks[this.weekTab] || this.currentPhase.weeks[0] || null;
    },
    sumWeekHours() {
      if (!this.currentAzra) {
        return '00:00';
      }
      let sum = 0;
      this.days.forEach(d => {
        const m = HOURS_PATTERN.exec(String(this.currentAzra['hours_' + d.day] || '').trim());
        if (m) {
          sum += parseInt(m[1]) * 60 + parseInt(m[2]);
        }
      });
      const hours = Math.floor(sum / 60);
      const minutes = sum % 60;
      return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
    },
    sumValenceWeekHours() {
      if (!this.currentAzra) {
        return '0,00';
      }
      let sum = 0;
      this.days.forEach(d => {
        sum += this.parseValence(this.currentAzra['valence_hours_' + d.day]);
      });
      return sum.toFixed(2).replace('.', ',');
    },
  },
  watch: {
    selectedBisId(bisId) {
      if (bisId === undefined || bisId === null) {
        return;
      }
      this.loadDetail(bisId);
    },
    phaseTab() {
      this.weekTab = 0;
    },
  },
  created() {
    this.showLoader();
    dpApi.settings()
        .then(settings => {
          this.hideLoader();
          this.settings = settings || null;
          if (settings && settings.schema_installed === false) {
            this.schemaMissing = true;
          }
        })
        .catch(this.handleError);
    this.showLoader();
    dpApi.raster()
        .then(list => {
          this.hideLoader();
          this.raster = list || [];
        })
        .catch(this.handleError);
  },
  methods: {
    // the loader is shared by parallel requests and hidden when the last one finishes
    showLoader() {
      this.pending++;
      if (this.loader === undefined) {
        this.loader = this.$loading.show();
      }
    },
    hideLoader() {
      this.pending = Math.max(0, this.pending - 1);
      if (this.pending === 0 && this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    handleError(res) {
      this.hideLoader();
      if (isAuthError(res)) {
        window.location = Redirect_Login;
        return;
      }
      if (res && res.status === 409 && res.body && res.body.code === 'SCHEMA_MISSING') {
        this.schemaMissing = true;
        return;
      }
      if (!(res && 'status' in res)) {
        console.error(res);
      }
      this.errorMessage = errorText(res);
      this.showErrorMessage = true;
    },
    loadDetail(bisId) {
      this.requestedBisId = bisId;
      this.showLoader();
      dpApi.rasterDetail(bisId)
          .then(detail => {
            this.hideLoader();
            // ignore late answers of a previously selected pattern
            if (this.requestedBisId !== bisId) {
              return;
            }
            this.detail = detail && detail.main_azra ? detail : null;
            this.phaseTab = 0;
            this.weekTab = 0;
          })
          .catch(this.handleError);
    },
    weekKey(week, i) {
      return (week.bis_id || '') + '_' + i;
    },
    imPlanerVerwenden() {
      this.$router.push({path: '/dienstplanung/zuordnung', query: {
        azra: this.detail.main_azra.bis_id, phase: this.currentPhase.active_from, nr: this.weekTab + 1, schritt: 2}});
    },
    formatName({active_from, active_to}) {
      return this.formatActive(active_from) + " - " + this.formatActive(active_to);
    },
    formatActive(active) {
      const splits = String(active || '').split('-');
      return splits.length === 2 ? splits[1] + '.' + splits[0] : String(active || '');
    },
    parseValence(value) {
      const n = parseFloat(String(value || '').trim().replace(',', '.'));
      return isNaN(n) ? 0 : n;
    },
    displayHours(value) {
      const v = String(value || '').trim();
      return v !== '' ? v : '00:00';
    },
    displayValence(value) {
      return this.parseValence(value).toFixed(2).replace('.', ',');
    },
    displayRange(value) {
      const v = String(value || '').trim();
      return v !== '' ? v : '00:00-00:00';
    },
  },
};
</script>

<style scoped>

::v-deep label {
  margin-bottom: initial;
}

.theme--light.v-label {
  color: black;
}

.list-col {
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
}

.list-scroll {
  overflow-y: auto;
  max-height: calc(100vh - 55px - 2.55rem - 120px);
}

.detail-col {
  overflow-y: auto;
  max-height: calc(100vh - 55px - 2.55rem - 64px);
}

.tabs-col {
  min-width: 0;
}

.day-col {
  border-right: 1px solid grey;
  border-top: 1px solid grey;
  min-width: 0;
}

.custom-col-1 {
  flex: 0 0 14.285%;
  max-width: 14.285%;
}

::v-deep .v-input input {
  color: black;
}

</style>
